import { color } from './color';
import { fonts } from './fonts';
import { fontWeights } from './fonts';

export default { color, fonts, fontWeights };
